import { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import styles from "./sellModal.module.scss";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { SellModalProps, Props } from "../../interfaces/components";
import BasicInfo from "./BasicInfo/BasicInfo";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { bindActionCreators, Dispatch } from "@reduxjs/toolkit";
import PriceContainer from "../../containers/Sell/PriceContainer";
import PicturesVideo from "../../containers/Sell/PicturesVideoContainer";


const SellModal = ({ 
    children, 
    isPatentFound = false, 
    vehicleData,
    getBrands,
    cleanGetBrands,
    setBrand,
    getModels,
    cleanGetModels,
    setModel,
    getVersions,
    getYears,
    cleanGetYears,
    brands,
    models,
    versions,
    years,
    fetchingVersions,
    accidentsReported,
    personalUse,
    soleOwner,
    isFoundPlate,
    request_id, 
    getSuggestedPrice,
    setRecord,
    kms,
    setKms,
    setFuel,
    setColor,
    setYear,
    color,
    fuel, 
    version,
    setVersion,
    year,
    plate,
    vehicleType,
    setType,
    transmission,
    setTransmission,
    doors,
    setDoors,
    cleanGetVersions,
    getAdditionalCharacters,
    additionalCharacters,
    setAdditionalCharacters,
    setSelectedAdditionalCharacters,
    selectedAdditionalCharacters,
    setRegion,
    region,
    getRegions,
    regions
}: Props) => {
    const [expanded, setExpanded] = useState<string | false>('panel1');
    const [completedSteps, setCompletedSteps] = useState<string[]>([]);
    const location = useLocation();
    const [isStep1Valid, setIsStep1Valid] = useState(false);
const [isStep2Valid, setIsStep2Valid] = useState(false);

    useEffect(() => {
        const fromDetail = localStorage.getItem('linzeReturnFromDetail');
        if (fromDetail === 'true') {
            setCompletedSteps([]);
            setExpanded('panel1')
          localStorage.removeItem('linzeReturnFromDetail');
        }
      }, []);
      

    const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    useEffect(() => {
        getAdditionalCharacters();
    }, [getAdditionalCharacters]);

    console.log('additionalCharacters', additionalCharacters);

    return (
        <div className={styles.searchContainer}>
            <h1 className={styles.pageTitle}>Vamos a publicar tu vehículo</h1>
            {!isFoundPlate && (
                <div className={styles.alertMessage}>
                    <InfoOutlinedIcon className={styles.icon} />
                    <p>
                    ¡Oops! No encontramos tu vehículo en las bases de Autored. Deberás completar la info de forma manual
                    </p>
                </div>
            )}
            <div className={styles.sellModalContainer}>
                <div className={styles.accordionContainer}>
                    <Accordion 
                        expanded={expanded === 'panel1'} 
                        onChange={handleChange('panel1')} 
                        className={styles.accordion}
                    >
                        <AccordionSummary
                            expandIcon={<span style={{ color: '#7100FF', fontSize: '15px', marginRight: '10px' }}>
                                {expanded === 'panel1' ? <span style={{ color: '#484848', fontSize: '18px' }}>1/3</span> : 'Editar'}
                            </span>}
                            className={styles.accordionSummary}
                        >
                            <div className={styles.stepHeader}>
                                {expanded !== 'panel1' && (
                                    <span className={`${styles.stepNumber} ${completedSteps.includes('panel1') ? styles.completed : ''}`}>
                                        {completedSteps.includes('panel1') && (
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="currentColor"/>
                                            </svg>
                                        )}
                                        Paso 1
                                    </span>
                                )}
                                <h3>Información básica</h3>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <BasicInfo
                            onValidityChange={(isValid: boolean) => setIsStep1Valid(isValid)}
                                setYear={setYear || (() => {})}
                                kms={kms}
                                setKms={setKms}
                                isPatentFound={isFoundPlate}
                                initialData={vehicleData}
                                color={vehicleData?.color || ''}
                                fuel={vehicleData?.fuel || ''}
                                version={vehicleData?.version_id ? {
                                    id: vehicleData.version_id,
                                    name: vehicleData.version_name
                                } : null}
                                versions={versions || []}
                                getVersions={getVersions}
                                getYears={getYears}
                                years={years}
                                cleanGetYears={cleanGetYears}
                                fetchingVersions={false}
                                getModels={getModels}
                                regions = {regions}
                                getRegions= {getRegions || (() => {})}
                                cleanGetModels={cleanGetModels}
                                setModel={setModel}
                                getBrands={getBrands}
                                cleanGetBrands={cleanGetBrands}
                                cleanGetVersions={cleanGetVersions}
                                setBrand={setBrand}
                                brands={brands}
                                isFoundPlate={isFoundPlate}
                                setVersion={setVersion}
                                setFuel={setFuel}
                                setColor={setColor}
                                year={vehicleData?.year || 0}
                                plate={vehicleData?.plate || ''}
                                vehicleType={vehicleData?.vehicle_type || ''}
                                setType={setType}
                                transmission={vehicleData?.transmission || ''}
                                setTransmission={setTransmission}
                                doors={vehicleData?.doors || 5}
                                setDoors={setDoors}
                                models={models || { selected: null, fetching: 'idle', data: [] }}
                                getSuggestedPrice={getSuggestedPrice}
                                setRecord={setRecord}
                                request_id={request_id}
                                getAdditionalCharacters={getAdditionalCharacters}
                                additionalCharacters={additionalCharacters}
                                setSelectedAdditionalCharacters={setSelectedAdditionalCharacters ?? (() => {})}
                                selectedAdditionalCharacters={selectedAdditionalCharacters}
                                setAdditionalCharacters={setAdditionalCharacters}
                                setRegion={setRegion || (() => {})}
                                region={region || null}
                                onContinue={() => {
                                    setCompletedSteps(prev => [...prev, 'panel1']);
                                    setExpanded('panel2');
                                }}
                            />
                        </AccordionDetails>
                    </Accordion>

                    {completedSteps.includes('panel1') && (
                        <Accordion 
                            expanded={expanded === 'panel2'} 
                            onChange={handleChange('panel2')}
                            className={styles.accordion}
                        >
                            <AccordionSummary
                                expandIcon={<span style={{ color: '#7100FF', fontSize: '15px', marginRight: '10px' }}>
                                    {expanded === 'panel2' ? <span style={{ color: '#484848', fontSize: '18px' }}>2/3</span> : 'Editar'}
                                </span>}
                                className={styles.accordionSummary}
                            >
                                <div className={styles.stepHeader}>
                                    {expanded !== 'panel2' && (
                                        <span className={`${styles.stepNumber} ${completedSteps.includes('panel2') ? styles.completed : ''}`}>
                                            {completedSteps.includes('panel2') && (
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="currentColor"/>
                                                </svg>
                                            )}
                                            Paso 2
                                        </span>
                                    )}
                                    <h3>Fotos y videos</h3>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <PicturesVideo 
                                onValidityChange={(isValid: boolean) => setIsStep2Valid(isValid)}
                                    onContinue={() => {
                                        setCompletedSteps(prev => [...prev, 'panel2']);
                                        setExpanded('panel3');
                                    }}
                                />
                            </AccordionDetails>
                        </Accordion>
                    )}

                    {completedSteps.includes('panel2') && (
                        <Accordion 
                            expanded={expanded === 'panel3'} 
                            onChange={handleChange('panel3')}
                            className={styles.accordion}
                        >
                            <AccordionSummary
                                expandIcon={<span style={{ color: '#7100FF', fontSize: '15px', marginRight: '10px' }}>
                                    {expanded === 'panel3' ? <span style={{ color: '#484848', fontSize: '18px' }}>3/3</span> : 'Editar'}
                                </span>}
                                className={styles.accordionSummary}
                            >
                                <div className={styles.stepHeader}>
                                    {expanded !== 'panel3' && (
                                        <span className={`${styles.stepNumber} ${completedSteps.includes('panel3') ? styles.completed : ''}`}>
                                            {completedSteps.includes('panel3') && (
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="currentColor"/>
                                                </svg>
                                            )}
                                            Paso 3
                                        </span>
                                    )}
                                    <h3>Precio y negociación</h3>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <PriceContainer 
                                 isStep1Valid={isStep1Valid}
                                 isStep2Valid={isStep2Valid}
                                    onContinue={() => {
                                        setCompletedSteps(prev => [...prev, 'panel3']);
                                    }}
                                />
                            </AccordionDetails>
                        </Accordion>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SellModal;